import axios from "axios";
import socketService from "./socketService";

const SESSION_STORAGE_KEYS = [
  "access_token",
  "user",
  "impersonating",
  "admin_token",
  "admin_user",
  "active_institution",
  "support_session",
  "platform_session_backup",
];

const clearSession = () => {
  SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  window.dispatchEvent(new Event("impersonation-changed"));
};

const commanApi = async (
  data = {},
  url = "",
  method = "POST",
  is_FormData = false,
  options = {},
) => {
  try {
    const publicRequest = options?.publicRequest === true;
    const token = publicRequest ? null : localStorage.getItem("access_token");

    const headers = {};
    if (!is_FormData) {
      headers["Content-Type"] = "application/json";
    }

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.request({
      url,
      method,
      data,
      headers,
    });

    if (!publicRequest && ["Token expired", "not token found", "Invalid token", "User not found"].includes(response.data.message) && response.data.status === false) {
      // Do NOT force-logout if an admin is currently impersonating another user.
      const isImpersonating = !!localStorage.getItem("impersonating");
      if (!isImpersonating) {
        socketService.disconnect();
        clearSession();
        window.location.href = "/login";
      }
      return response.data;
    }

    return response.data;
  } catch (error) {
    // Axios errors contain config.data and Authorization headers. Never send
    // those objects to DevTools or remote console collectors.
    let safePath = '';
    try {
      safePath = new URL(url, window.location.origin).pathname;
    } catch (_urlError) {
      safePath = String(url || '').split('?', 1)[0];
    }
    console.error("JwtService API request failed", {
      method: String(method || 'POST').toUpperCase(),
      path: safePath,
      status: error?.response?.status || null,
      code: error?.code || null,
    });
    // Extract the backend's specific error message/detail if available (e.g. 409 duplicate email)
    const responseData = error?.response?.data;
    const backendMessage =
      (typeof responseData === "object" && responseData !== null)
        ? (responseData.detail || responseData.message || null)
        : (typeof responseData === "string" ? responseData : null);
    return {
      status: false,
      message: backendMessage || "An error occurred. Please try again.",
      data: null,
    };
  }
};

// ✅ export as an object to keep same usage
export const JwtService = {
  commanApi,
  clearSession,
};
